const headers = [
  {
    text: 'storage.storage_register-date',
    value: 'registerDate',
    width: '110px'
  },
  {
    text: 'common.common_storage',
    value: 'shipTpLoading',
    width: '170px'
  },
  {
    text: 'order.order_rep',
    value: 'userId',
    width: '90px'
  },
  {
    text: 'common.common_status',
    value: 'status'
  }
]

const tableKey = 'storageMoveId'

const productListHeaders = [
  {
    text: 'common.product_product-number',
    value: 'product.productNumber',
    sortable: false,
    width: '8%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'common.product_product-name',
    value: 'productName',
    sortable: false,
    width: '30%',
    class: 'rgba(151, 198, 234, 0.1)'
  },
  {
    text: 'product.product_supplier',
    value: 'product.supplierId',
    sortable: false,
    width: '12%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'common.product_capacity',
    value: 'product.capacity',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  },
  {
    text: 'storage.storage_storage-move-quantity',
    value: 'quantity',
    sortable: false,
    width: '7%',
    class: 'rgba(151, 198, 234, 0.1)',
    align: 'center'
  }
]

export default { headers, tableKey, productListHeaders }
